/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Router } from '@angular/router';
import { NB_AUTH_OPTIONS } from '../../auth.options';
import { getDeepFromObject } from '../../helpers';
import { ApiService } from '../../../services/api.service';
import { URLConfig } from '../../../../configs/url-config';



@Component({
  selector: 'nb-reset-password-page',
  styleUrls: ['./reset-password.component.scss'],
  templateUrl: './reset-password.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NbResetPasswordComponent {

  redirectDelay: number = 0;
  showMessages: any = {};
  strategy: string = '';

  submitted = false;
  errors: string[] = [];
  messages: string[] = [];
  user: any = {};

  constructor(
              private _apiService: ApiService,
              private route: ActivatedRoute,
              @Inject(NB_AUTH_OPTIONS) protected options = {},
              protected cd: ChangeDetectorRef,
              protected router: Router) {

    this.redirectDelay = this.getConfigValue('forms.resetPassword.redirectDelay');
    this.showMessages = this.getConfigValue('forms.resetPassword.showMessages');
    this.strategy = this.getConfigValue('forms.resetPassword.strategy');
    this.route.queryParams.subscribe((params) => {
      if (params?.email) {
        this.user.email = params.email;
      }
    });
  }

  resetPass(): void {
    this.errors = this.messages = [];
    this.submitted = true;
    const payload = {
      email: this.user.email,
      resetCode: this.user.resetCode,
      newPassword: this.user.newPassword,
    };

    this._apiService.postRequest(URLConfig.resetPassword, payload).subscribe((result:any) => {
      this._apiService.success('Password reset successful. Please login.');
      this.router.navigate(['/auth/login']);
      this.submitted = false;
      this.cd.detectChanges();
    },
    (error)=>{
      this.submitted = false;
      this.cd.detectChanges();
    });
  }

  getConfigValue(key: string): any {
    return getDeepFromObject(this.options, key, null);
  }
}
